<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-lg>
      <ModelTitle
        title="Edit Technician"
        @close="close()"
        :color="$style.purchase.titlebar"
      />

      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              :hide-details="nameErrors.length === 0"
              outlined
              dense
              :error-messages="nameErrors"
              v-model="technician.name"
              ref="technicianName"
              label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="technician.phoneNumber"
              label="Phone Number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="technician.email"
              label="Email Address"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="technician.address"
              label="Address"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              outlined
              dense
              hide-details
              v-model="technician.city"
              label="City"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="technician.state"
              label="State"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              outlined
              hide-details
              dense
              v-model="technician.zip"
              label="Zip Code"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import technicianService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTechnician: {
      type: Object,
    },
  },
  name: "update-technician",
  data() {
    return {
      loading: false,
      dialog: false,
      technician: {
        name: null,
        email: null,
        phoneNumber: null,
        address: null,
        city: null,
        state: null,
        zip: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    technician: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.technician.name.$dirty) return errors;
      if (!this.$v.technician.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      if (val) {
        this.technician = this.editTechnician;
        this.$nextTick(() => {
          this.$refs.technicianName.focus();
        });
      }
      this.dialog = val;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.technician = {
        name: null,
        email: null,
        phoneNumber: null,
        address: null,
        city: null,
        state: null,
        zip: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return technicianService
          .update(this.technician.id, this.technician)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "technician is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
